exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".curr-month-overview[data-v-7375ff0c] {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n.curr-month-overview .excellent-header-tea[data-v-7375ff0c] {\n  -webkit-box-align: start !important;\n  -webkit-align-items: flex-start !important;\n      -ms-flex-align: start !important;\n          align-items: flex-start !important;\n}\n.curr-month-overview .excellent-header-tea .header-tea-item[data-v-7375ff0c] {\n  width: -webkit-calc(50% - 15px);\n  width: calc(50% - 15px);\n}\n", ""]);

// exports
